import { Component, Input } from '@angular/core';
import { AmbassadorPromotionLevelEnum } from '../../modules/ambassadors-promotion/models/enums/AmbassadorPromotionLevelEnum';

@Component({
  selector: 'app-ambassador-promotion-level',
  standalone: false,
  templateUrl: './ambassador-promotion-level.component.html'
 })
export class AmbassadorPromotionLevelComponent {
@Input() currentLevel = null
ambassadorPromotionLevelEnum = AmbassadorPromotionLevelEnum
}
